<template>
  <b-modal
      v-model="openModal"
      centered
      scrollable
      size="xl"
      title="Détails de l'essai CPTu"
      @hidden="onModalHidden"
      @show="fetchCptuDetails"
  >
    <!-- Tabs Navigation -->
    <b-tabs card pills>
      <!-- Tableau Récapitulatif -->
      <b-tab active title="Récapitulatif">
        <b-table
            :items="layersSummary"
            class="mb-0 text-nowrap"
            hover
            responsive
            striped
        >
          <template #head(SBT_mode)>
            SBT
          </template>
          <template #cell(thk)="data">
            {{ toFixed(data.value) }}
          </template>
          <template #cell(SBT_mode)="data">
            <b-badge variant="info">{{ data.value }}</b-badge>
          </template>
          <template #cell(Ic_med)="data">
            {{ toFixed(data.value, 2) }}
          </template>
          <template #cell(phi_deg_med)="data">
            {{ toFixed(data.value, 1) }}
          </template>
          <template #cell(cu_kpa_med)="data">
            {{ toFixed(data.value, 0) }}
          </template>
          <template #cell(gamma_nat)="data">
            {{ toFixed(data.value, 1) }}
          </template>
          <template #cell(M_kpa_med)="data">
            {{ toFixed(data.value, 0) }}
          </template>
          <template #cell(Qt_med)="data">
            {{ toFixed(data.value, 2) }}
          </template>
          <template #cell(Fr_med)="data">
            {{ toFixed(data.value, 2) }}
          </template>
          <template #cell(Bq_med)="data">
            {{ toFixed(data.value, 2) }}
          </template>
          <template #cell(qc_mpa_med)="data">
            {{ toFixed(data.value, 1) }}
          </template>
        </b-table>
      </b-tab>

      <!-- Graphiques -->
      <b-tab title="Graphiques">
        <p>Graphiques des données CPTu (à implémenter)</p>
      </b-tab>

      <!-- Paramètres -->
      <b-tab title="Paramètres">
        <p>Paramètres de l'analyse CPTu (à implémenter)</p>
      </b-tab>
    </b-tabs>

    <!-- Footer Actions -->
    <template #modal-footer>
      <b-button variant="outline-secondary" @click="openModal = false">
        Fermer
      </b-button>
      <b-button variant="primary">
        <feather-icon class="mr-50" icon="DownloadIcon"/>
        Exporter rapport
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {BBadge, BButton, BModal, BTab, BTable, BTabs} from "bootstrap-vue";
import store from "@/store";

export default {
  name: 'CptuDetailsModal',
  components: {BBadge, BTable, BButton, BTab, BTabs, BModal},
  props: {
    cptuId: {
      type: String,
      default: null,
    },
    openModeler: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      cptuData: null,
    }
  },
  computed: {
    openModal: {
      get() {
        return this.openModeler
      },
      set() {
        this.$emit('update:openModeler', false)
      }
    },
    layersSummary() {
      if (!this.cptuData || !this.cptuData?.layers) return [];

      return this.groupBy('SBT_mode');
    }
  },
  methods: {
    toFixed(value, precision = 1) {
      return value == null ? '—' : Number(value).toFixed(precision)
    },
    onModalHidden() {
      this.$emit('hidden')
    },
    groupBy(attribute) {
      const groups = [];
      let actualGroup = null;
      const layers = this.cptuData?.layers ?? [];

      layers.forEach(layer => {
        const attrValue = layer[attribute];

        // STEP 1
        if (!actualGroup || actualGroup[0][attribute] !== attrValue) {
          // create new group if empty or if SBT_mode value changed
          actualGroup = [layer];
          groups.push(actualGroup);
        } else {
          // add to actual group
          actualGroup.push(layer);
        }
      })

      // STEP 2 : merge each group
      const result = groups.map(g => {
        return g.reduce((merge, layer) => {
          const zTop = Math.min(merge.z_top, layer.z_top);
          const zBot = Math.max(merge.z_bot, layer.z_bot);
              return {
                ...merge,
                z_top: zTop,
                z_bot: zBot,
                thk: zBot - zTop,
              };
            },
            {...g[0]}
        );
      })
      return result;

    },
    fetchCptuDetails() {
      store
          .dispatch("cptu/fetchCptu", {id: this.cptuId})
          .then((cptu) => {
            this.cptuData = cptu;
          })
          .catch((error) => {
            if (error.response.status === 404) {
              this.cptuData = undefined;
            }
          });
    }
  },
}
</script>